import { uploadImage } from 'js/library/services/StorageManager';
import { createCard, updateCard } from 'js/library/utils/API/apiCards';
import { firebaseDatabase } from 'js/library/utils/firebaseUtils';
import { convertToMillis, b64toBlob } from 'js/library/utils/helpers';

export async function updateCardsStoreAction(data) {
  data.cardId = data.cardId === null ? firebaseDatabase.ref('Cards').push().key : data.cardId;

  const currentDate = Date.now();

  const url = window.location.pathname;
  const isCreatingCard = url.includes('cadastrarCards');

  //Mobile images
  if (data.loadedMobileFile !== null) {
    data.oldImageMobile = data.imageMobile.replace('cards/', '');
    data.imageMobile = 'storage:' + data.cardId + ':mobile:' + currentDate;
    data.loadedMobileFile = b64toBlob(data.loadedMobileFile);
  }

  //Details images
  if (data.loadedDetailsFile !== null) {
    data.oldImageDetails = data.imageMobileDetails.replace('cards/', '');
    data.imageMobileDetails = 'storage:' + data.cardId + ':mobileDetails:' + currentDate;
    data.loadedDetailsFile = b64toBlob(data.loadedDetailsFile);
  }

  //Web images
  if (data.loadedWebFile !== null) {
    data.oldImageWeb = data.imageWeb.replace('cards/', '');
    data.imageWeb = 'storage:' + data.cardId + ':web:' + currentDate;
    data.loadedWebFile = b64toBlob(data.loadedWebFile);
  }

  // Função para criar o payload base (comum para ambos os casos)
  const createBasePayload = (isUpdate = false) => {
    // Determina o action baseado no cardType
    let actionValue;
    switch (data.cardType) {
      case 'card_item':
        actionValue = 'promotion_businessPartner';
        break;
      case 'card_url':
        actionValue = 'browser';
        break;
      default:
        actionValue = data.action; // Mantém o action original para card_list
    }

    const basePayload = {
      action: actionValue,
      appFilter: {},
      description: data.description,
      orgs: data.orgs,
      platform: data.platform,
      title: data.title,
      disableDate: convertToMillis(data.disableDate),
      enableDate: convertToMillis(data.enableDate),
      isPublished: data.isPublished,
      location: data.location,
      keyWordsSet: data.keywordsList,
      images: {
        ...(data.icon && { icon: data.icon }),
        web: isUpdate ? data.imageWeb : data.loadedWebFile !== null ? data.imageWeb : data.webFile,
        mobile: isUpdate
          ? data.imageMobile.includes('cards/')
            ? data.imageMobile
            : 'cards/' + data.imageMobile
          : data.loadedMobileFile !== null
          ? 'cards/' + data.imageMobile
          : data.mobileFile,
        mobileDetails: isUpdate
          ? data.imageMobileDetails.includes('cards/')
            ? data.imageMobileDetails
            : 'cards/' + data.imageMobileDetails
          : data.loadedDetailsFile !== null
          ? 'cards/' + data.imageMobileDetails
          : data.detailsFile,
      },
      priority: parseInt(data.priority, 10) || null,
      type: data.cardType,
      status: data.isPublished ? 1 : 0,
      subtitle: data.subtitle,
    };

    // Processa as propriedades do appFilter
    if (data.itemId !== '') {
      basePayload.appFilter.itemId = data.itemId;
    } else {
      delete basePayload.appFilter.itemId;
    }

    if (data.query !== '') {
      basePayload.appFilter.query = data.query;
      if (data.cardType !== 'card_list') {
        basePayload.orderType = data.orderType;
        basePayload.geoRadius = data.geoRadius;
        basePayload.hasVoucher = data.hasVoucher;
      }
    } else {
      delete basePayload.appFilter.query;
    }

    if (data.url !== '') {
      basePayload.appFilter.url = data.url;
    } else {
      delete basePayload.appFilter.url;
    }

    // Verifica se o appFilter está vazio após todas as operações
    if (Object.keys(basePayload.appFilter).length === 0) {
      delete basePayload.appFilter;
    }

    // Adiciona storePlacesQuery apenas para card_list
    if (data.cardType === 'card_list') {
      basePayload.storePlacesQuery = {
        ...data.storePlacesQuery,
        orderType: data.orderType,
        geoRadius: data.geoRadius,
        ...(data.hasVoucher && { hasVoucher: data.hasVoucher }),
        ...(data.hasPromo && { hasPromo: data.hasPromo }),
      };
    }

    return basePayload;
  };

  // Cria os objetos finais
  const createData = createBasePayload(false);
  const updateData = createBasePayload(true);

  const storageFolder = 'cards';

  const commonImageUploadPromises = [
    uploadImage(storageFolder, data.loadedWebFile, data.imageWeb),
    uploadImage(storageFolder, data.loadedMobileFile, data.imageMobile),
    uploadImage(storageFolder, data.loadedDetailsFile, data.imageMobileDetails),
  ];

  const specificPromise = isCreatingCard
    ? createCard(createData)
    : updateCard(data.cardId, updateData);

  const resultPromise = await Promise.all([specificPromise, ...commonImageUploadPromises]);

  return resultPromise;
}
